export const AckoDriveWhiteLogo = 'https://acko-cms.ackoassets.com/Acko_Drive_Horizontal_Full_White_29d44dafcd.svg'
export const ReviewAnimationContants = { ANIMATION_DURATION: 500, INTERVAL: 3000 }
